// @ts-check
import { StyledColorSquare } from './StatePicker.style';
import {
  ISSUE_STATUSES,
  LINB_ISSUE_STATES
} from '../../../../state/issue.statuses';
import _ from 'lodash';
import { lightColorPalette } from '@linearb/linui-common';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import { LBButton } from '@linearb/buzz';

const StatePicker = ({ stateTypes, onClickStateType, totalCategories }) => {
  const issueStatuses = _.values(
    _.omit(ISSUE_STATUSES, LINB_ISSUE_STATES.ACC_DONE)
  );

  const onClick = state => {
    const { key } = state;
    onClickStateType(key);
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.PROJECT_PROGRESSION,
      click_type:
        TRACKING.CLICK.PROJECT_PROGRESSION.PROGRESSION_TABLE.FILTERS.BY_STATUS,
      value: key
    });
  };

  return (
    <div className='flex flex-row gap-1'>
      {issueStatuses.map(state => {
        const { name, color, key } = state;
        const total = totalCategories[key];
        const isSelected = stateTypes.includes(key);
        return (
          <LBButton
            key={key}
            variant={isSelected ? 'outline' : 'ghost'}
            data-testid={`state_picker_${key}`}
            onClick={() => onClick(state)}
          >
            <StyledColorSquare
              color={isSelected ? color : lightColorPalette.lbBlue_40}
            />
            {total} {_.capitalize(name)}
          </LBButton>
        );
      })}
    </div>
  );
};

export default StatePicker;
